function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.5,
  cy: 26.5,
  r: 26.5,
  fill: "#C25982"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 35.375C19.8807 35.375 21 34.2557 21 32.875C21 31.4943 19.8807 30.375 18.5 30.375C17.1193 30.375 16 31.4943 16 32.875C16 34.2557 17.1193 35.375 18.5 35.375Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.875 35.375C34.2557 35.375 35.375 34.2557 35.375 32.875C35.375 31.4943 34.2557 30.375 32.875 30.375C31.4943 30.375 30.375 31.4943 30.375 32.875C30.375 34.2557 31.4943 35.375 32.875 35.375Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 32.875H12.25V17.875H30.375V32.875H21",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.375 32.875V22.25H35.7321L39.75 27.5625V32.875H35.882",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIcon1 = function SvgIcon1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon1.36d350fe.svg";
export { ForwardRef as ReactComponent };